import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {PlaceholderWrapperComponent} from "../../../../core/components/placeholder/placeholder-wrapper";
import {DeviceViewModel} from "../../../../core/models/device.view-model";

export class RecentFormWidgetPartialPlaceholderComponentProps extends BaseProps {
  device: DeviceViewModel;
}

export const RecentFormWidgetPartialPlaceholder = (props: RecentFormWidgetPartialPlaceholderComponentProps) => {
  const balloons: Array<Object> = [];

  for (let i = 0; i < 5; i++) {
    balloons.push({
      key: i,
      className: 'recent-form-widget-partial-placeholder-balloon'
    });
  }

  return (
    <PlaceholderWrapperComponent className={'recent-form-widget-partial-placeholder-container'}>
      <div className={['recent-form-widget-partial-placeholder-content',props.device.isSmallView ? 'recent-form-widget-partial-placeholder-small-view' : ''].join(' ')}>
        <div className={'recent-form-widget-partial-placeholder-balloon-container'}>
          {
            balloons.map((balloon) => <div className={balloon.className} key={balloon.key}/>)
          }
        </div>
        <div className={'recent-form-widget-partial-placeholder-title'}/>
        <div className={'recent-form-widget-partial-placeholder-balloon-container'}>
          {
            balloons.map((balloon) => <div className={balloon.className} key={balloon.key}/>)
          }
        </div>
      </div>
    </PlaceholderWrapperComponent>
  )
}
